// extracted by mini-css-extract-plugin
module.exports = {"ResponsivePlaceholder":"X9OWatcOnGsQmpzwowcEk","PlaceholderActivated":"_2RLDWTS9vq7aj8IxG7gzX-","PlaceholderWrapper":"_12h-BWHgjDWYf3B4BzpPWm"};